import styled from 'styled-components'
import { theme } from '../../styles/theme'

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${theme.colors.overlay.primary};
  z-index: 9999;
  inset: 0;
  overflow: hidden;
`

export const Content = styled.div`
  position: absolute;
  width: calc(100% - 32px);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${theme.colors.white};
  z-index: 9999;
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: ${theme.border.mediumRadius};
  overflow-y: auto;

  @media (min-width: 768px) {
    width: 500px;
  }
`

export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  height: 164px;
`

export const Video = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: ${theme.border.largeRadius};
`

export const TextsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 11px;
  margin-bottom: 16px;

  span {
    font-weight: ${theme.font.bold};
  }
`

export const FirstText = styled.div`
  font-size: ${theme.font.sizes.large};
  color: ${theme.colors.green2};
  text-align: center;
  margin: 0 2px 16px 2px;
`

export const SecondText = styled.div`
  font-size: ${theme.font.sizes.normal};
  color: ${theme.colors.gray900};
  text-align: center;
  margin: 0 34px 9px 34px;
`

export const ThirdText = styled.div`
  font-size: ${theme.font.sizes.small};
  color: ${theme.colors.gray700};
  text-align: center;
  margin: 0 16px;
`

export const ConfirmButton = styled.button`
  background-color: ${theme.colors.green2};
  color: ${theme.colors.white};
  font-size: ${theme.font.sizes.medium};
  font-weight: ${theme.font.bold};
  border-radius: ${theme.border.mediumRadius};
  border: none;
  padding: 12px 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 16px;
`
